module.exports = __webpack_public_path__ + "media/images/recruit/guide/icon-order-guide-fda4a29c5ffaffa390287b8d6befdde2.svg";